import { Component } from "react";
import { Helmet } from "react-helmet";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { getPaymentFlowRoutes } from "./pages/payment-requests/Routes";
import { getCheckout, getPaymentRequest } from "@api";
import YapilyCallback from "./pages/shared/YapilyCallback";
import { openPaymentLinkRoutes } from "./pages/open-payment-link/Routes";
import { eapRoutes } from "./pages/embedded-account-payment/Routes";
import EmbeddedAccountsTestPage from "./pages/embedded-account-payment/TestPage";
import NotFound from "./pages/NotFounds";
import FAQs from "./pages/FAQs";
import ExpressCheckout from "./pages/express-checkout/ExpressCheckout";
import RouterErrorBoundary from "./pages/RouterErrorBoundary";

export default class App extends Component {
  static displayName = App.name;

  render() {
    const nr_script = () => {
      if (window.location.hostname.includes("dev")) {
        return window.location.origin + "/js/nr-dev-min.js";
      } else if (window.location.hostname.includes("staging")) {
        return window.location.origin + "/js/nr-staging-min.js";
      } else {
        return window.location.origin + "/js/nr-prod-min.js";
      }
    };

    const generalPaymentFlows = [
      {
        flowId: "pay",
        getDataFunction: getPaymentRequest,
        routeIds: [
          "selectinvoices",
          "paymentmethod",
          "paybybank",
          "paybycard",
          "paybybnpl",
          "confirmpaybybank",
          "success",
          "cancelled",
          "processing",
          "paymentfailed",
        ],
      },
      {
        flowId: "checkout",
        getDataFunction: getCheckout,
        routeIds: [
          "paymentmethod",
          "paybybank",
          "paybycard",
          "paybybnpl",
          "confirmpaybybank",
          "processing",
          "paymentfailed",
        ],
      },
    ];

    const router = createBrowserRouter([
      ...generalPaymentFlows.map(({ flowId, getDataFunction, routeIds }) =>
        getPaymentFlowRoutes({ flowId, getDataFunction, routeIds })
      ),
      openPaymentLinkRoutes,
      eapRoutes,
      {
        path: "/yapilycallback",
        element: <YapilyCallback />,
        errorElement: <RouterErrorBoundary />,
      },
      {
        path: "/embeddedtestpage",
        element: <EmbeddedAccountsTestPage />,
        errorElement: <RouterErrorBoundary />,
      },
      {
        path: "/express-checkout/:id",
        element: <ExpressCheckout />,
        errorElement: <RouterErrorBoundary />,
      },
      {
        path: "/faqs",
        element: <FAQs />,
        errorElement: <RouterErrorBoundary />,
      },
      {
        path: "*",
        element: <NotFound />,
        errorElement: <RouterErrorBoundary />,
      },
    ]);

    return (
      <>
        <Helmet>
          {!window.location.host.includes("localhost") && (
            <script type="text/javascript" src={nr_script()} />
          )}
        </Helmet>
        <RouterProvider router={router} />
      </>
    );
  }
}
